import * as popover from "@zag-js/popover"
import {normalizeProps, useMachine} from "@zag-js/solid";
import {createMemo, createUniqueId, JSX, splitProps} from "solid-js";

export interface ZagPopoverProps extends Partial<popover.Props> {
    children: (api: popover.Api) => JSX.Element;
}

export default function ZagPopover(props: ZagPopoverProps) {
    const [_, zagProps] = splitProps(props, ["children"])
    const service = useMachine(
        popover.machine,
        () => ({id: createUniqueId(), ...zagProps})
    )
    const api = createMemo(() => popover.connect(service, normalizeProps))
    return <props.children {...api()}/>
}